export default (axios, baseURL) => async (clientSid, tenantInfo) => {
  const url = `/hub/clients/${encodeURIComponent(clientSid)}/csv/tenants`;

  const axiosConfig = {
    method: 'POST',
    baseURL,
    url,
    data: { tenantInfo }
  };

  const axiosResponse = await axios(axiosConfig);

  if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
    throw new Error('Invalid response from gateway');
  }
  return axiosResponse.data;
};
